"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _default = function _default(block, contentState) {
  var blockKey = block.getKey();

  var replaceSelection = _draftJs.SelectionState.createEmpty(blockKey).merge({
    focusOffset: block.getLength()
  });

  return _draftJs.Modifier.replaceText(contentState, replaceSelection, block.getText());
};

exports.default = _default;
module.exports = exports.default;